<template>
	<Card>
		<div class="container-fluid">
			<div class="row pt-3 pl-2">
				<h5 class="back-title" @click="back()">
					<i class="fa fa-angle-left"></i> Back To Admin
				</h5>
			</div>
			<div class="row mb-4">
				<h4 class="account-title col-sm-3 offset-sm-2">Link Sites to Admin Users</h4>
			</div>
			<div class="row form-group pl-5 pr-5">
				<label for="name" class="col-sm-2 offset-sm-3">Admin User:</label>
                <div class="col-sm-7">
                    <select
                        id="admin_user"
                        @change="selectField($event)"
                        v-model="adminUser"
                    >
                        <option v-for="admin in adminUsers" :value="admin.id">
                            {{ admin.name }}
                        </option>
                    </select>
                </div>
			</div>
            <div class="row form-group pl-5 pr-5">
				<label for="name" class="col-sm-2 offset-sm-3">Sites:</label>
                <div class="col-sm-7">
                    <multi-select
                        ref="multselect"
                        :type="'site'"
                        :options="linkedSites"
                        @checked="onCheck"
                    ></multi-select>
                </div>
			</div>
            <div v-if="errorMessages.length > 0"  class="mb-5" style="justify-content: center;text-align: left;">
                <p v-for="error in errorMessages" style="color: #8D448B !important; display: block;">
                    {{ error }}
                </p>
            </div>
            <div class="row form-group text-right pr-4 mt-5 mb-5">
                <button  @click="linkSitestoAdminUser" class="update-button col-sm-2 offset-sm-5">
                    Link Sites to Admin User
                </button>
            </div>
		</div>
	</Card>
</template>

<script>
import Card from "@/components/Cards/Card";
import MultiSelect from "@/components/Inputs/multiSelectInput";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

export default {
	name: "ManageLinkedSites",
	components: {
		Card,
		MultiSelect
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			user: 'auth/getUser',
		})
	},
	data() {
		return {
			adminUser: null,
            adminUsers: [],
            linkedSites: [],
            errorMessages: [],
            managedSites: []
		};
	},
	async created() {
		const sites = await this.getSites(this.user.id);
        sites.forEach(element => {
			let item = {
				flag: false,
				id: element.id,
				name: element.sitename
			}

			this.linkedSites.push(item);
		});
        this.adminUsers = await this.getAdminUsers();
	},
	methods: {
		...mapActions({
			getSites: "admin/getSites",
            getAdminUsers: "admin/getAdminUsers",
            updateLinkedUsers: "admin/updateLinkedUsers"
		}),
        onCheck(val) {
			console.log(val)
            this.managedSites = val;
		},
        selectField(e) {
            console.log(e.target.value);
            this.adminUser = e.target.value
        },
		back() {
			this.$router.push({ name: "admin" });
		},
        async linkSitestoAdminUser() {
            if (this.adminUser == null) {
				this.errorMessages.push("Please select admin user");
			}

			if (this.managedSites.length == 0) {
				this.errorMessages.push("Please one site at least");
			}

			if (this.errorMessages.length == 0) {
                let data = {
                    admin_id: this.adminUser,
                    sites: this.managedSites
                }
                await this.updateLinkedUsers(data);
                this.$toasted.show("Selected Sites are linked to admin user successfully", {
					type: "success",
					duration: 2500,
				});

				this.managedSites = [];
				this.adminUser = null;
				this.$refs.multselect.disselectall();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
label {
    color: white !important;
}
#admin_user {
    height: 40px;
    background-color: #1e365d;
    color: white !important;
    opacity: 0.9;
    border: 1px solid #fdfdfd;
    border-radius: 4px;
	width: 25%;
}

.update-button {
	width: 120px;
	height: 40px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover {
		background-color: #1f5881;
	}
}
</style>
